import { makeFieldStyleSelector } from "@client/content/modules/selectors";
import { type RootContainerProps } from "@client/content/types";
import { getNoImageUrl } from "@client/lib/assets";
import { type AppState, Status } from "@client/types";
import { connect } from "react-redux";
import { checkout, removeFromCart, updateCart } from "../actions";
import { localStateSelector } from "../selectors";
import { type Cart } from "../types";
import Component, { type ActionProps, type MapProps } from "./component";

const makeMapStateToProps = () => {
  const fieldStyleSelector = makeFieldStyleSelector();

  return (state: AppState, props: RootContainerProps): MapProps => {
    const localState = localStateSelector(state, props);

    return {
      ...props,
      fieldStyle: fieldStyleSelector(state, props),
      isBusy: localState.status === Status.Saving,
      isEditMode: state.isEditMode,
      currencyCode: localState.currencyCode,
      noImageUrl: getNoImageUrl(),
      cart: localState.cart,
      shouldDisplayTax: localState.shouldDisplayTax
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: RootContainerProps): ActionProps => ({
  onChange: (cart: Cart.Cart) => dispatch(updateCart({ id: props.id, source: props.source }, cart)),
  onDelete: (productId: string) => dispatch(removeFromCart({ id: props.id, source: props.source }, productId)),
  onCheckout: () => dispatch(checkout({ id: props.id, source: props.source }))
});

export default connect(makeMapStateToProps, mapDispatchToProps)(Component);
